/**
 * 수정 폼/모달 푸터의 "변경사항 있음/없음" 힌트 — 문구·색·a11y를 한 곳에서 결정한다.
 *
 * 기존에는 23곳이 `<span className="text-brand-600">변경사항이 있습니다</span>` 식으로 복제돼
 * 문구(있습니다/없음)·극성·`role="status"` 유무가 제각각이었다. 이 부품으로 수렴한다:
 * - 문구: dirty면 "변경사항이 있습니다", 아니면 "변경사항 없음"
 * - 색: dirty면 `text-brand-600`, 아니면 `text-ink-400`
 * - `role="status"`로 스크린리더에 상태 전이를 알린다(항상 마운트된 채 텍스트만 바뀌어야
 *   라이브 리전이 동작하므로, 호출부는 이 컴포넌트를 조건부로 언마운트하지 말고 mode 게이트
 *   안에서 항상 렌더할 것).
 *
 * 크기/여백 등 배치는 맥락마다 달라(text-xs/text-sm, mr-auto self-center 등) `className`으로
 * 주입한다 — 색/문구/role만 이 컴포넌트가 소유한다. (font-size를 이 컴포넌트가 하드코딩하면
 * className의 text-sm과 Tailwind 상 충돌하므로 크기는 넘겨받는다. 미지정 시 text-xs.)
 */
export function DirtyHint({
  isDirty,
  className,
}: {
  isDirty: boolean;
  className?: string;
}) {
  const hasSize = className ? /(?:^|\s)text-(?:xs|sm|base|lg)(?:\s|$)/.test(className) : false;
  return (
    <span
      role="status"
      className={`${hasSize ? '' : 'text-xs '}${isDirty ? 'text-brand-600' : 'text-ink-400'}${
        className ? ` ${className}` : ''
      }`}
    >
      {isDirty ? '변경사항이 있습니다' : '변경사항 없음'}
    </span>
  );
}
